import React from 'react';

const InternationalStudent = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} fill="none" {...props}>
    <path
      fill="#fff"
      d="M20 14.969A8.026 8.026 0 0 1 11.973 23C7.538 23 4 19.256 4 14.818 4 10.38 7.387 7.169 11.653 7H12c4.427 0 8 3.54 8 7.978v-.01Z"
    />
    <path
      fill="#fff"
      d="M11.653 7c-4.177 4.527-4.177 10.424 0 15.991V7ZM12.356 7c4.177 4.527 4.177 10.424 0 15.991V7Z"
    />
    <path
      stroke="#224251"
      strokeLinejoin="round"
      strokeWidth={0.7}
      d="M11.653 7C7.387 7.169 4 10.38 4 14.818S7.538 23 11.973 23A8.026 8.026 0 0 0 20 14.969v.009A7.963 7.963 0 0 0 12 7h-.347Zm0 0c-4.177 4.527-4.177 10.424 0 15.991M12.356 7c4.177 4.527 4.177 10.424 0 15.991m-7.467-4.438h14.267M5.333 10.55h13.334M4 14.996h16"
    />
    <path
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.7}
      d="M19 4.25 15.64 6 12 5l-3.5.875L5 4.25 12 1l7 3.25Z"
    />
    <path stroke="#224251" strokeLinecap="round" strokeWidth={0.7} d="M17 8c0-1.657-2.723-2.5-5-2.5S7 6.343 7 8" />
    <path fill="#224251" d="M18.7 4a.2.2 0 1 0-.4 0h.4Zm-.4 0v2.9h.4V4h-.4Z" />
    <circle cx={18.49} cy={7.4} r={0.6} stroke="#224251" strokeWidth={0.4} />
  </svg>
);

export default InternationalStudent;
